import { AppointmentStatus } from 'types';
import { isThisWeek, isToday, isTomorrow, subtractTimeZone } from 'helpers';

export const SHOWING_TABS = {
  Pending: 'Pending',
  NewFeedback: 'New Feedback',
  Today: 'Today',
  Tomorrow: 'Tomorrow',
  ThisWeek: 'This Week',
  Upcoming: 'Upcoming',
  Past: 'Past',
  Decline: 'Declined',
  Cancelled: 'Canceled',
  Archive: 'Archive',
};

export const emptyText = 'No Showings.';

const filterShowings = (data) => {
  return data?.filter((item) => item.AppointmentStatus !== AppointmentStatus.Pending);
};
const todayShowings = (showings) =>
  filterShowings(showings.filter((item) => isToday(subtractTimeZone(item.AppointmentDate))));

const tomorrowShowings = (showings) =>
  filterShowings(showings.filter((item) => isTomorrow(subtractTimeZone(item.AppointmentDate))));

const thisWeekShowings = (showings) =>
  filterShowings(
    showings.filter(
      (item) =>
        isThisWeek(subtractTimeZone(item.AppointmentDate)) &&
        !isToday(subtractTimeZone(item.AppointmentDate)) &&
        !isTomorrow(subtractTimeZone(item.AppointmentDate)),
    ),
  );

// showingAggregate?.Upcoming
const upcomingShowings = (showings) =>
  filterShowings(showings?.filter((item) => !isThisWeek(subtractTimeZone(item.AppointmentDate))));

export const prepareShowingData = ({ showingAggregate }) => {
  const showings = [
    ...(showingAggregate?.Pending || []),
    ...(showingAggregate?.Upcoming || []),
    ...(showingAggregate?.NewFeedback || []),
  ];

  return {
    pending: showingAggregate?.Pending || [],
    newFeedback: showingAggregate?.NewFeedback || [],
    today: todayShowings(showings),
    tomorrow: tomorrowShowings(showings),
    thisWeek: thisWeekShowings(showings),
    upcoming: upcomingShowings(showings),
    archivedShowings: {
      past: showingAggregate?.Past || [],
      declined: showingAggregate?.Declined || [],
      cancelled: showingAggregate?.Canceled || [],
    },
  };
};

export const archivedShowingsDataSource = (archivedValue, archivedShowings) => {
  const { past, declined, cancelled } = archivedShowings;
  if (archivedValue === SHOWING_TABS.Past) return past;
  if (archivedValue === SHOWING_TABS.Decline) return declined;
  if (archivedValue === SHOWING_TABS.Cancelled) return cancelled;

  return [];
};
export const getArchivedShowingOptions = (archivedShowings) => {
  const { past, declined, cancelled } = archivedShowings;

  return [
    { label: SHOWING_TABS.Past, count: past.length },
    { label: SHOWING_TABS.Decline, count: declined.length },
    { label: SHOWING_TABS.Cancelled, count: cancelled.length },
  ];
};
